import  { useState, useEffect } from "react";
import { t } from  "../../i18n";
import fetchData from "../../api/fetchApi";

export default function AutoReplyPage() {
  const [triggerInputs, setTriggerInputs] = useState([""]);
  const [reply, setReply] = useState("");
  const [likeMethod, setLikeMethod] = useState("contains");
  const [workingTime, setWorkingTime] = useState("00:00-00:00"); // NEW
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [autoReplies, setAutoReplies] = useState([]);
  const [selectedRowIdx, setSelectedRowIdx] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);
  const [editData, setEditData] = useState(null);

  // Fetch all auto-replies
  useEffect(() => {
    fetchAutoReplies();
  }, []);

  const fetchAutoReplies = async () => {
    try {
      const data = await fetchData("autoresponses");
      setAutoReplies(Array.isArray(data) ? data : []);
    } catch (err) {
      setAutoReplies([]);
    }
  };

  const handleTriggerInputChange = (idx, value) => {
    setTriggerInputs((prev) => {
      const arr = [...prev];
      arr[idx] = value;
      return arr;
    });
  };

  const handleAddTriggerInput = () => {
    setTriggerInputs((prev) => [...prev, ""]);
  };

  const handleRemoveTriggerInput = (idx) => {
    setTriggerInputs((prev) => prev.length > 1 ? prev.filter((_, i) => i !== idx) : prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError("");
    try {
      const triggerValue = triggerInputs.filter(Boolean).join("-");
      await fetchData(
        "autoresponse",
        "POST",
        JSON.stringify({
          keyword: triggerValue,
          response: reply,
          like_method: likeMethod,
          working_time: workingTime,
        })
      );
      setSuccess(true);
      setTriggerInputs([""]);
      setReply("");
      setLikeMethod("contains");
      setWorkingTime("00:00-00:00");
      await fetchAutoReplies();
    } catch (err) {
      setError(err.message || "خطأ غير معروف");
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (idx) => {
    setEditIdx(idx);
    setEditData({
      keyword: autoReplies[idx].keyword,
      response: autoReplies[idx].response,
      like_method: autoReplies[idx].like_method,
      working_time: autoReplies[idx].working_time || "00:00-00:00",
      uuid: autoReplies[idx].uuid,
    });
  };

  const handleEditChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditSave = async () => {
    if (!editData?.uuid) return;
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await fetchData(
        `autoresponse?uuid=${editData.uuid}`,
        "PUT",
        JSON.stringify({
          keyword: editData.keyword,
          response: editData.response,
          like_method: editData.like_method,
          working_time: editData.working_time,
        })
      );
      setSuccess(true);
      setEditIdx(null);
      setEditData(null);
      await fetchAutoReplies();
    } catch (err) {
      setError(err.message || "خطأ أثناء التعديل");
    } finally {
      setLoading(false);
    }
  };

  const handleEditCancel = () => {
    setEditIdx(null);
    setEditData(null);
  };

  // Delete handler
  const handleDelete = async () => {
    if (selectedRowIdx === null || !autoReplies[selectedRowIdx]?.uuid) return;
    if (!window.confirm("هل أنت متأكد أنك تريد حذف هذا الرد الآلي؟")) return;
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await fetchData(
        `autoresponse?uuid=${autoReplies[selectedRowIdx].uuid}`,
        "DELETE"
      );
      setSuccess(true);
      setSelectedRowIdx(null);
      await fetchAutoReplies();
    } catch (err) {
      setError(err.message || "خطأ أثناء الحذف");
    } finally {
      setLoading(false);
    }
  };

  // Activate handler
  const handleActivate = async () => {
    if (selectedRowIdx === null || !autoReplies[selectedRowIdx]?.uuid) return;
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await fetchData(
        `autoresponce/active?uuid=${autoReplies[selectedRowIdx].uuid}`,
        "PUT"
      );
      setSuccess(true);
      await fetchAutoReplies();
    } catch (err) {
      setError(err.message || "خطأ أثناء التفعيل");
    } finally {
      setLoading(false);
    }
  };

  // Deactivate handler
  const handleDeactivate = async () => {
    if (selectedRowIdx === null || !autoReplies[selectedRowIdx]?.uuid) return;
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await fetchData(
        `autoresponce/deactivate?uuid=${autoReplies[selectedRowIdx].uuid}`,
        "PUT"
      );
      setSuccess(true);
      await fetchAutoReplies();
    } catch (err) {
      setError(err.message || "خطأ أثناء إلغاء التفعيل");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto bg-white  p-6 rounded-xl shadow">
      <p2 className="text-2xl font-extrabold mb-2 text-gray-800  flex items-center gap-2">
        {t("auto-reply-list")}
      </p2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium ">{t("trigger-text") || "النص المستلم"}</label>
          <div className="flex flex-col gap-2">
            {triggerInputs.map((val, idx) => (
              <div key={idx} className="flex gap-2 items-center">
                <input
                  type="text"
                  className="w-full border rounded px-3 py-2  "
                  value={val}
                  onChange={e => handleTriggerInputChange(idx, e.target.value)}
                  required={idx === 0}
                  placeholder={t("trigger-placeholder") || "مثال: مرحبا"}
                />
                {triggerInputs.length > 1 && (
                  <button
                    type="button"
                    className="bg-red-500 text-white px-2 py-1 rounded"
                    onClick={() => handleRemoveTriggerInput(idx)}
                  >
                    -
                  </button>
                )}
                {idx === triggerInputs.length - 1 && (
                  <button
                    type="button"
                    className="bg-green-600 text-white px-2 py-1 rounded"
                    onClick={handleAddTriggerInput}
                  >
                    +
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
        <div>
          <label className="block mb-1 font-medium ">{t("auto-reply")}</label>
          <textarea
            className="w-full border rounded px-3 py-2  "
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            required
            placeholder={t("reply-placeholder") || "مثال: أهلاً بك!"}
          />
        </div>
        <div>
          <label className="block mb-1 font-medium ">طريقة المطابقة</label>
          <select
            className="w-full border rounded px-3 py-2  "
            value={likeMethod}
            onChange={e => setLikeMethod(e.target.value)}
          >
            <option value="contains">يحتوي على</option>
            <option value="exact">مطابقة تامة</option>
            {/* أضف طرق أخرى إذا كانت مدعومة */}
          </select>
        </div>
        <div>
          <label className="block mb-1 font-medium ">وقت العمل (اختياري)</label>
          <input
            type="datetime-local"
            className="w-full border rounded px-3 py-2  "
            value={workingTime}
            onChange={e => setWorkingTime(e.target.value)}
            placeholder="مثال: 09:00-17:00"
          />
        </div>
        <div className="text-sm text-gray-500  mb-2">
          {
            (
              <>
                يمكنك استخدام الرموز التعبيرية مثل
                <span className="text-yellow-500 mx-1">😊</span>
                <span className="text-xs bg-gray-100  px-2 py-0.5 rounded mx-1">
                  :smile:
                </span>
                في الردود.
              </>
            )
          }
        </div>
        <div className="text-sm w-full text-left">
          <button
            type="submit"
            className="bg-[#013D4E] text-white px-4 py-2 rounded hover:bg-indigo-700"
            disabled={loading}
          >
            {loading ? t("loading") : t("save")}
          </button>
        </div>
        {success && <div className="text-green-600 mt-2">{t("success") + "!"}</div>}
        {error && <div className="text-red-600 mt-2">{error}</div>}
      </form>

      {/* Table of auto replies */}
      <div className="mt-8">
        <h3 className="text-lg font-semibold mb-2 ">{t("auto-reply-list")}</h3>
          {/* Actions Dropdown */}
            <div className="flex justify-end mt-4">
              <div className="relative">
                <button
                  className="bg-gray-700  text-white px-4 py-2 rounded flex items-center gap-2 hover:bg-gray-800 "
                  onClick={() => setDropdownOpen(prev => !prev)}
                  disabled={selectedRowIdx === null}
                >
                  <span>عمليات</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M19 9l-7 7-7-7" /></svg>
                </button>
                {dropdownOpen && (
                  <div className="absolute left-0 mt-2 w-48 bg-white  border  rounded shadow-lg z-10">
                    <ul>
                  
                      {/* استخدم زر تعديل الرد هنا فقط */}
                      <li
                        className="px-4 py-2 hover:bg-gray-100  cursor-pointer flex items-center gap-2"
                        onClick={() => handleEditClick(selectedRowIdx ? selectedRowIdx : 0)}
                      >
                        <span>تعديل الرد</span>
                        <span>🔑</span>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-green-100  text-green-600  cursor-pointer flex items-center gap-2"
                        onClick={handleActivate}
                      >
                       تعطيل الرد
                        <span>🔌</span>
                      
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-yellow-100  text-yellow-600  cursor-pointer flex items-center gap-2"
                        onClick={handleDeactivate}
                      >
                        <span>تفعيل الرد</span>
                        <span>🔌</span>
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-red-100  text-red-600cursor-pointer flex items-center gap-2"
                        onClick={handleDelete}
                      >
                        <span>حذف</span>
                        <span>🗑️</span>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
        <div className="overflow-x-auto">
          <div className="rounded shadow p-4 bg-white ">
            <div className="flex justify-between items-center mb-4">
              <div className="text-sm text-gray-700 ">
                عدد البيانات التى تم العثور عليها: <span className="text-yellow-600 font-bold">{autoReplies.length}</span>
              </div>
              <input
                type="text"
                placeholder="بحث"
                className="border rounded px-3 py-1 w-1/3 focus:outline-none bg-gray-50  "
              />
            </div>
            
            <table className="w-full text-right border-collapse">
              <thead>
                <tr className="bg-gray-100 ">
                  <th className="py-2 px-3"></th>
                  <th className="py-2 px-3 text-gray-700 ">النص المستلم</th>
                  <th className="py-2 px-3 text-gray-700 ">الرد التلقائي</th>
                  <th className="py-2 px-3 text-gray-700 ">طريقة المطابقة</th>
                  <th className="py-2 px-3 text-gray-700 ">وقت العمل</th>
                  <th className="py-2 px-3 text-gray-700 ">الحالة</th>
                  {/* حذف عمود تعديل */}
                </tr>
              </thead>
              <tbody>
                {autoReplies?.map((row, idx) => (
                  <tr
                    key={row.id || idx}
                    className={`border-t  ${selectedRowIdx === idx ? "bg-indigo-50 " : ""}`}
                    onClick={() => setSelectedRowIdx(idx)}
                    style={{ cursor: "pointer" }}
                  >
                    <td className="py-2 px-3">
                      <input
                        type="checkbox"
                        checked={selectedRowIdx === idx}
                        onChange={() => setSelectedRowIdx(idx)}
                        onClick={e => e.stopPropagation()}
                      />
                    </td>
                    {/* عرض البيانات فقط بدون تعديل مباشر في الجدول */}
                    <td className="py-2 px-3 text-blue-600  underline cursor-pointer">{row.keyword}</td>
                    <td className="py-2 px-3 text-gray-700 ">{row.response}</td>
                    <td className="py-2 px-3 text-gray-700 ">{row.like_method}</td>
                    <td className="py-2 px-3 text-gray-700 ">{row.working_time || "-"}</td>
                    <td className="py-2 px-3 text-gray-700 ">
                      {row.status === 'Active' ? (
                        <span className="text-green-600">مفعل</span>
                      ) : (
                        <span className="text-red-600">غير مفعل</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          
            {/* نافذة التعديل المنبثقة */}
            {editIdx !== null && editData && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
                <div className="bg-white  rounded-xl shadow-lg p-6 max-w-sm w-full relative">
                  <h3 className="text-lg font-semibold mb-4 ">{t("edit-auto-reply")}</h3>
                  <div className="space-y-4">
                    <div>
                      <label className="block mb-1 font-medium ">{t("trigger-text") || "النص المستلم"}</label>
                      <input
                        type="text"
                        className="w-full border rounded px-3 py-2  "
                        value={editData.keyword}
                        onChange={(e) => handleEditChange("keyword", e.target.value)}
                        required
                        placeholder={t("trigger-placeholder") || "مثال: مرحبا"}
                      />
                    </div>
                    <div>
                      <label className="block mb-1 font-medium ">{t("auto-reply")}</label>
                      <input
                        type="text"
                        className="w-full border rounded px-3 py-2  "
                        value={editData.response}
                        onChange={(e) => handleEditChange("response", e.target.value)}
                        required
                        placeholder={t("reply-placeholder") || "مثال: أهلاً بك!"}
                      />
                    </div>
                    <div>
                      <label className="block mb-1 font-medium ">طريقة المطابقة</label>
                      <select
                        className="w-full border rounded px-3 py-2  "
                        value={editData.like_method}
                        onChange={e => handleEditChange("like_method", e.target.value)}
                      >
                        <option value="contains">يحتوي على</option>
                        <option value="exact">مطابقة تامة</option>
                      </select>
                    </div>
                    <div>
                      <label className="block mb-1 font-medium ">وقت العمل (اختياري)</label>
                      <input
                        type="datetime-local"
                        className="w-full border rounded px-3 py-2  "
                        value={editData.working_time}
                        onChange={e => handleEditChange("working_time", e.target.value)}
                        placeholder="مثال: 09:00-17:00"
                      />
                    </div>
                    <div className="flex gap-2">
                      <button
                        className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 flex-1"
                        onClick={handleEditSave}
                        disabled={loading}
                      >
                        {loading ? t("loading") : t("save")}
                      </button>
                      <button
                        className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 flex-1"
                        onClick={handleEditCancel}
                        disabled={loading}
                      >
                        إلغاء
                      </button>
                    </div>
                    {success && <div className="text-green-600 mt-2">{t("success") + "!"}</div>}
                    {error && <div className="text-red-600 mt-2">{error}</div>}
                  </div>
                  <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                    onClick={handleEditCancel}
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12" /></svg>
                  </button>
                </div>
              </div>
            )}
            {/* Pagination */}
            <div className="flex justify-between items-center mt-4">
              <div>
                <select className="border rounded px-2 py-1  ">
                  <option>15</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <button className="px-2">&lt;&lt;</button>
                <button className="px-2">&lt;</button>
                <span>1/1</span>
                <button className="px-2">&gt;</button>
                <button className="px-2">&gt;&gt;</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
